// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__P8gzv","header":"ReportDetails_header__3oPGk","title":"ReportDetails_title__1VOLG","left":"ReportDetails_left__2-yHA"};